import Utils from "../../utility";

const initialState = {
  list: [],
  count: 0,
  offset: 1,
  take: 20,
};

export const aiGrnReducer = (state = initialState, action) => {
  switch (action.type) {
    case Utils.ActionName.AI_GRN:
      return { ...state, ...action.payload };
    case Utils.ActionName.RESET_AI_GRN:
      return { ...initialState };
    default:
      return state;
  }
};
